<template>
    <div :id="componentId">

  <button
    style="width:100%;"

    type="button"
    class="btn"
    :class="{'btn-danger':!popoverShown, 'icon-trash':!popoverShown, 'btn-secondary':popoverShown}"
    @click="onButtonClick"
    :disabled = "componentsDisabled || disabled"
  > {{popoverShown ? cancelLabel : label}}


    </button>
    <div v-show="popoverShown" :id="popperId" class="popper">
    <div class="card">
        <div class="card-body">
            <div v-if="errors.length" class="ajax-error-alert error-display alert alert-danger">
                    <p class="mb-0" v-for="(value, key) in errors" :key="key">{{value}}</p>
            </div>
            <button class="btn btn-danger" type="button" @click="submitDeleteForm" :disabled="componentsDisabled">
                <span v-if="successNotify" class="icon-ok-circle"> Delete Success!</span>
                <span v-else-if="componentsDisabled" class="icon-clock"> Processing...</span>
                <span v-else class="icon-trash"> Confirm Delete</span>
            </button>
        </div>
        <div class="popper__arrow"></div>
    </div>
    </div>
    </div>


</template>

<script>
import componentMixin from './component-mixin.js'

export default {
    inheritAttrs: false,
    mixins:[
        componentMixin
    ],
    props: {
        title:{
            type:String,
            default:"Are you sure?",
        },
        label:{
            type:String,
            default:"Delete",
        },
        placement:{
            type:String,
            default:"auto",
        },
        cancelLabel:{
            type:String,
            default:"Cancel Delete",
        },
        action:String,
        disabled:{
            type:Boolean,
            default:false,
        },

    },
    data(){
        return {
            content:`<div>

                    </div>`,
            componentId:this.makeRandomId(),
            popperId:this.makeRandomId(),
            popoverShown:false,
            errors:[],
            componentsDisabled:false,
            successNotify:false,
        }
    },
    mounted(){
        var reference = document.getElementById(this.componentId);
        var popper = document.getElementById(this.popperId);
        this.popperInstance = new Popper(reference, popper, {
          placement:this.placement,
        });
    },
    methods:{
        onButtonClick(){
            this.popoverShown = !this.popoverShown;
        },
        submitDeleteForm(){
            this.componentsDisabled = true;
            this.errors = [];
            this.$emit('pre-submit');
            this.popperInstance.update();
            axios.delete(this.action)
            .then((response) => {
                this.successNotify = true;
                this.$emit('success', response.data);
                this.popperInstance.update();
                window.setTimeout(()=>{
                    this.componentsDisabled = false;
                    this.successNotify = false;
                    this.$emit('success-complete', response.data);
                    this.popoverShown = false;
                    this.popperInstance.update();
                }, 3000)
            })
            .catch((error) => {
                if (error.response.status == 422 && error.response.data.errors){ // validation error

                    Object.values(error.response.data.errors).forEach((val)=>{
                        val.forEach((inner)=>{
                            this.errors.push(inner);
                        });
                    });

                } else {

                    this.errors.push(error.message);
                    if(error.response && error.response.data){
                        this.errors.push(error.response.data.message);
                    }
                    console.log(error);
                    console.log(error.response);

                }
                this.componentsDisabled = false;
                this.popperInstance.update();
            });

        },
    },
    watch:{
        popoverShown(newVal, oldVal){
            $(`#${this.componentId}`).popover(newVal ? 'show' : 'hide')
            if (! newVal){
                this.errors = [];
            }
            this.popperInstance.update();

        },
        disabled(newVal, oldVal){
            if (newVal){
                this.popoverShown = false;
                this.popperInstance.update();
            }
        },
        action(newVal, oldVal){
            this.popoverShown = false;
            this.popperInstance.update();
        }
    }

}
</script>

<style>
.popper,
  .tooltip {
      position: absolute;
      padding: 10px;
      text-align: center;
  }
  .popper .popper__arrow,
  .tooltip .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 10px;
  }

  .tooltip .tooltip-arrow,
  .popper .popper__arrow {
      border-color: white;
  }
  .popper[x-placement^="top"],
  .tooltip[x-placement^="top"] {
      margin-bottom: 10px;
  }
  .popper[x-placement^="top"] .popper__arrow,
  .tooltip[x-placement^="top"] .tooltip-arrow {
      border-width: 10px 10px 0 10px;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
      bottom: -10px;
      left: calc(50% - 10px);
      margin-top: 0;
      margin-bottom: 0;
  }
  .popper[x-placement^="bottom"],
  .tooltip[x-placement^="bottom"] {
      margin-top: 10px;
  }
  .tooltip[x-placement^="bottom"] .tooltip-arrow,
  .popper[x-placement^="bottom"] .popper__arrow {
      border-width: 0 10px 10px 10px;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      top: -10px;
      left: calc(50% - 10px);
      margin-top: 0;
      margin-bottom: 0;
  }
  .tooltip[x-placement^="right"],
  .popper[x-placement^="right"] {
      margin-left: 10px;
  }
  .popper[x-placement^="right"] .popper__arrow,
  .tooltip[x-placement^="right"] .tooltip-arrow {
      border-width: 10px 10px 10px 0;
      border-left-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
      left: -10px;
      top: calc(50% - 10px);
      margin-left: 0;
      margin-right: 0;
  }
  .popper[x-placement^="left"],
  .tooltip[x-placement^="left"] {
      margin-right: 10px;
  }
  .popper[x-placement^="left"] .popper__arrow,
  .tooltip[x-placement^="left"] .tooltip-arrow {
      border-width: 10px 0 10px 10px;
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
      right: -10px;
      top: calc(50% - 10px);
      margin-left: 0;
      margin-right: 0;
  }

</style>
